module.exports = __webpack_public_path__ + "static/media/026-customer-service.ebb13de0.svg";